<template>
  <div class="receipt-card">
    <div class="bill-border"></div>
  </div>
</template>
<script>
export default {
  name: 'TPassBillBorder',
};
</script>
